import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/FormBits";
import { api, formatError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("As senhas não são iguais.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      toast.success("Senha alterada! Entre com a nova senha.");
      navigate("/entrar", { replace: true });
    } catch (err) {
      setError(formatError(err));
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-3xl font-extrabold tracking-tight">Criar nova senha</h1>
      <p className="mb-8 text-slate-500">Escolha uma senha com pelo menos 8 caracteres.</p>
      <div className="space-y-4 rounded-md border border-slate-200 bg-white p-6">
        {token ? (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <FormField id="reset-password" label="Nova senha" type="password" minLength={8} required value={form.password} onChange={set("password")} />
            <FormField id="reset-confirm" label="Repita a nova senha" type="password" minLength={8} required value={form.confirm} onChange={set("confirm")} />
            <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-slate-900 hover:bg-[#0099DD]" data-testid="reset-submit">{busy ? "Salvando..." : "Salvar nova senha"}</Button>
          </form>
        ) : (
          <p className="rounded-md bg-amber-50 p-3 text-sm text-amber-800" data-testid="reset-missing-token">Este link está incompleto. Peça um novo link de recuperação.</p>
        )}
        {error && <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="reset-error">{error}</p>}
        <Link to="/recuperar-senha" className="block text-center text-sm font-semibold text-[#0099DD] hover:underline" data-testid="link-request-new">Pedir um novo link</Link>
      </div>
    </div>
  );
}
